import { inject, Injectable } from '@angular/core';
import { AzureLoginResult } from '@libs/shared/models';
import { Observable } from 'rxjs';
import { OAuthConfigService } from './oauth-config.service';

@Injectable()
export abstract class OAuthService {
  protected readonly configService: OAuthConfigService = inject(OAuthConfigService);

  public abstract login(): Observable<AzureLoginResult | undefined>;

  public abstract register(): Observable<AzureLoginResult | undefined>;

  public abstract logout(): Observable<void>;

  public abstract refreshToken(): Observable<AzureLoginResult | undefined>;
}
